import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    adapts,
    GoogleCloudStorageStoreReadSettingsAdapter
} from 'app/model/adapters/activities/copysource/store-read-settings/google-cloud-storage-store-read-settings.adapter';
import { SapDatasphereForGoogleCloudStorageReadSettings } from 'app/model/pipeline/copysource/store-read-settings/sap-datasphere-for-google-cloud-storage-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForGoogleCloudStorageReadSettings),
    asynchronous: true,
    adapts
})
export class SapDatasphereForGoogleCloudStorageReadSettingsAdapter extends GoogleCloudStorageStoreReadSettingsAdapter {}
